import { render, staticRenderFns } from "./BatchSamplesSampleDetails.vue?vue&type=template&id=3fca22de&scoped=true"
import script from "./BatchSamplesSampleDetails.vue?vue&type=script&lang=js"
export * from "./BatchSamplesSampleDetails.vue?vue&type=script&lang=js"
import style0 from "./BatchSamplesSampleDetails.vue?vue&type=style&index=0&id=3fca22de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fca22de",
  null
  
)

export default component.exports